import { productClassesMasterDataApi } from "@/apis/apis";
import MasterDataBaseTable from "../MasterDataBaseTable";
import { columns } from "./Columns";
import ProductClassModal from "@/Modals/WebDataManagement/MasterData/ProductClasses/Modal";

export default function ProductClassesPage() {
  return (
    <MasterDataBaseTable
      label="Product Classes"
      apiURL={productClassesMasterDataApi}
      columns={columns()}
      ModalComponent={ProductClassModal}
      importData={null}
      enableExport={false}
      enableSortData={false}
    />
  );
}
